import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/[lang]/articles/[slug]/page-client.jsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/assets/dashboard.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/assets/flag-en.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/assets/flag-es.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/assets/leaf.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/assets/leaves-by-2.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/assets/leaves-stacked.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/assets/linkedin.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/assets/logo.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/assets/merge.svg");
